// extracted by mini-css-extract-plugin
export default {"container":"l1_Vz","intersecting":"W0VMh","time":"RFkt3"};